import React, { useEffect, useState } from "react";
import { useParams, Link, useNavigate } from "react-router-dom";
import axios from "axios";
import { Table, Button, Modal, Form } from "react-bootstrap";
import { BASE_URL } from "config/config";
import FolderCard from "@pages/ged/components/FolderCard/FolderCard";
import { DocumentCard } from "@pages/ged/components/DocumentCard/DocumentCard";
import { useSelector } from "react-redux";
import { Search } from "@mui/icons-material";
import "./FolderDetail.scss";
import { FolderIcon } from "@assets/icons/FolderIcon";
import { FIleIcon } from "@assets/icons/FIleIcon";
import CreateDocumentModal from "@pages/ged/components/CreateDocumentModal/CreateDocumentModal";
import { t } from "i18next";
import { useTranslation } from "react-i18next";
const FolderDetail = () => {
  const { id } = useParams();
  const { t } = useTranslation();
  const [content, setContent] = useState({ folders: [], docs: [] });
  const [showModal, setShowModal] = useState(false);
  const [newFolderName, setNewFolderName] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
  const [folderSearchResults, setFolderSearchResults] = useState([]);
  const [documentSearchResults, setDocumentSearchResults] = useState([]);
  const [showDocumentModal, setShowDocumentModal] = useState(false);
  const [foldersAdd, setFoldersAdd] = useState([]);
  const [viewMode, setViewMode] = useState('list'); // 'list' or 'grid'
  const navigate = useNavigate();
  const currentUser = useSelector((state) => state.auth.user);
  const companyId = currentUser?.companyId?._id;
  const fetchContent = async () => {
    const res = await axios.get(`${BASE_URL}folders/${id}/content`);
    setContent(res?.data?.data);
    console.log("setContent", res?.data?.data);
  };
  useEffect(() => {
    fetchContent();
  }, [id]);
  const fetchFolders = async () => {
    try {
      const res = await axios.get(`${BASE_URL}folders/company/${companyId}`);
      const data = res?.data?.data || [];

      setFoldersAdd(data);
    } catch (err) {
      console.error("Erreur fetch folders:", err);
    }
  };
  useEffect(() => {
    fetchFolders();
  }, []);

  const createFolder = async () => {
    if (!newFolderName) return alert(t("ged.nomObligatoire"));
    await axios.post(`${BASE_URL}folders`, {
      name: newFolderName,
      parentId: id,
      companyId: companyId,
    });
    setNewFolderName("");

    fetchContent();
    setShowModal(false);
  };
  function getImageURL(id) {
    return `${BASE_URL}documentsFile/${id}/file`;
  }
  const handleSearch = () => {
    searchFolders();
    searchDocuments();
  };
  // 4️⃣ Recherche dossiers
  // ==========================
  const searchFolders = async () => {
    if (!searchQuery.trim()) {
      setFolderSearchResults([]);
      return;
    }
    try {
      const res = await axios.get(
        `${BASE_URL}folders/folder/search/${companyId}?query=${searchQuery}`
      );
      setFolderSearchResults(res?.data?.data || []);
    } catch (err) {
      console.error("Erreur recherche folders:", err);
    }
  };

  // ==========================
  // 5️⃣ Recherche documents
  // ==========================
  const searchDocuments = async () => {
    if (!searchQuery.trim()) {
      setDocumentSearchResults([]);
      return;
    }
    try {
      const res = await axios.get(
        `${BASE_URL}documentsFile/doc/search/${companyId}?query=${searchQuery}`
      );
      setDocumentSearchResults(res?.data?.data || []);
    } catch (err) {
      console.error("Erreur recherche documents:", err);
    }
  };
  return (
    <div className="folder-detail-page">
      {/* Header Section */}
      <div className="folder-header">
        <div className="container-fluid">
          <div className="row align-items-center">
            <div className="col-md-8">
              <div className="header-content">
                <button className="back-button" onClick={() => navigate(-1)}>
                  <i className="fas fa-arrow-left me-2"></i>
                  {t("ged.retour")}
                </button>
                <h1 className="page-title">
                  <i className="fas fa-folder-open me-3"></i>
                  {t("ged.contenu")}
                </h1>
                <p className="page-subtitle">
                  Gérez le contenu de ce dossier
                </p>
              </div>
            </div>
            <div className="col-md-4">
              <div className="header-actions">
                <Button
                  className="btn btn-outline-primary me-2"
                  onClick={() => setShowModal(true)}
                >
                  <i className="fas fa-folder-plus me-2"></i>
                  {t("ged.nouveauDos")}
                </Button>
                <Button
                  className="btn btn-primary"
                  onClick={() => setShowDocumentModal(true)}
                >
                  <i className="fas fa-file-upload me-2"></i>
                  {t("ged.nouveauDoc")}
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Search Section */}
      <div className="search-section">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12">
              <div className="search-container">
                <div className="search-bar">
                  <Search className="search-icon" />
                  <Form.Control
                    type="text"
                    placeholder="Rechercher dans ce dossier..."
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                    onKeyPress={(e) => {
                      if (e.key === "Enter") handleSearch();
                    }}
                    className="search-input"
                  />
                  <Button 
                    className="search-btn"
                    onClick={handleSearch}
                  >
                    <i className="fas fa-search"></i>
                  </Button>
                </div>
                <div className="filter-options">
                  <Button variant="outline-secondary" className="filter-btn">
                    <i className="fas fa-filter me-2"></i>
                    Filtres
                  </Button>
                  <Button variant="outline-secondary" className="sort-btn">
                    <i className="fas fa-sort me-2"></i>
                    Trier
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Main Content */}
      <div className="main-content">
        <div className="container-fluid">
          {/* Search Results */}
          {(folderSearchResults.length > 0 || documentSearchResults.length > 0) && (
            <div className="search-results">
              {folderSearchResults.length > 0 && (
                <div className="results-section">
                  <div className="section-header">
                    <h3 className="section-title">
                      <i className="fas fa-folder me-2"></i>
                      {t("ged.resutatDos")} ({folderSearchResults.length})
                    </h3>
                  </div>
                  <div className="folders-grid">
                    {folderSearchResults.map((f) => (
                      <FolderCard key={f._id} folder={f} />
                    ))}
                  </div>
                </div>
              )}
              
              {documentSearchResults.length > 0 && (
                <div className="results-section">
                  <div className="section-header">
                    <h3 className="section-title">
                      <i className="fas fa-file-alt me-2"></i>
                      {t("ged.resultatDoc")} ({documentSearchResults.length})
                    </h3>
                  </div>
                  <div className={`documents-container ${viewMode === 'grid' ? 'documents-grid' : 'documents-list'}`}>
                    {documentSearchResults.map((doc) => (
                      <DocumentCard key={doc._id} doc={doc} />
                    ))}
                  </div>
                </div>
              )}
            </div>
          )}

          {/* Folder Content */}
          <div className="folder-content">
            {/* Subfolders Section */}
            <div className="content-section">
              <div className="section-header">
                <h2 className="section-title">
                  <i className="fas fa-folder me-2"></i>
                  {t("ged.sousDos")} ({content.folders?.length || 0})
                </h2>
                <div className="view-options">
                  <Button variant="outline-secondary" size="sm" className="view-btn active">
                    <i className="fas fa-th me-1"></i>
                    Grille
                  </Button>
                  <Button variant="outline-secondary" size="sm" className="view-btn">
                    <i className="fas fa-list me-1"></i>
                    Liste
                  </Button>
                </div>
              </div>
              
              {content.folders?.length > 0 ? (
                <div className="folders-showcase">
                  <div className="folders-grid">
                    {content.folders.map((f) => (
                      <FolderCard key={f._id} folder={f} />
                    ))}
                  </div>
                  <div className="folders-summary">
                    <div className="summary-card">
                      <div className="summary-icon">
                        <i className="fas fa-folder"></i>
                      </div>
                      <div className="summary-content">
                        <h4>{content.folders.length} Dossiers</h4>
                        <p>Total des sous-dossiers</p>
                      </div>
                    </div>
                    <div className="summary-card">
                      <div className="summary-icon">
                        <i className="fas fa-chart-pie"></i>
                      </div>
                      <div className="summary-content">
                        <h4>Organisés</h4>
                        <p>Structure hiérarchique</p>
                      </div>
                    </div>
                    <div className="summary-card">
                      <div className="summary-icon">
                        <i className="fas fa-clock"></i>
                      </div>
                      <div className="summary-content">
                        <h4>Mis à jour</h4>
                        <p>Dernière modification</p>
                      </div>
                    </div>
                  </div>
                </div>
              ) : (
                <div className="empty-state">
                  <div className="empty-icon">
                    <i className="fas fa-folder-open"></i>
                  </div>
                  <h4>Aucun sous-dossier</h4>
                  <p>Ce dossier ne contient aucun sous-dossier pour le moment.</p>
                  <Button 
                    variant="primary" 
                    onClick={() => setShowModal(true)}
                    className="empty-action-btn"
                  >
                    <i className="fas fa-folder-plus me-2"></i>
                    Créer un sous-dossier
                  </Button>
                </div>
              )}
            </div>

            {/* Documents Section */}
            <div className="content-section">
              <div className="section-header">
                <h2 className="section-title">
                  <i className="fas fa-file-alt me-2"></i>
                  {t("ged.doc")} ({content.documents?.length || 0})
                </h2>
                <div className="view-options">
                  <Button 
                    variant="outline-secondary" 
                    size="sm" 
                    className={`view-btn ${viewMode === 'list' ? 'active' : ''}`}
                    onClick={() => setViewMode('list')}
                  >
                    <i className="fas fa-list me-1"></i>
                    Liste
                  </Button>
                  <Button 
                    variant="outline-secondary" 
                    size="sm" 
                    className={`view-btn ${viewMode === 'grid' ? 'active' : ''}`}
                    onClick={() => setViewMode('grid')}
                  >
                    <i className="fas fa-th me-1"></i>
                    Grille
                  </Button>
                </div>
              </div>
              
              {content.documents?.length > 0 ? (
                <div className={`documents-container ${viewMode === 'grid' ? 'documents-grid' : 'documents-list'}`}>
                  {content.documents.map((doc) => (
                    <DocumentCard key={doc._id} doc={doc} />
                  ))}
                </div>
              ) : (
                <div className="empty-state">
                  <div className="empty-icon">
                    <i className="fas fa-file-alt"></i>
                  </div>
                  <h4>Aucun document</h4>
                  <p>Ce dossier ne contient aucun document pour le moment.</p>
                  <Button 
                    variant="primary" 
                    onClick={() => setShowDocumentModal(true)}
                    className="empty-action-btn"
                  >
                    <i className="fas fa-file-upload me-2"></i>
                    Ajouter un document
                  </Button>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      {/* Create Folder Modal */}
      <Modal
        show={showModal}
        onHide={() => setShowModal(false)}
        centered
        className="modal-create-folder"
        id="modal-create-folder">
        <Modal.Header closeButton>
          <Modal.Title>
            <i className="fas fa-folder-plus me-2"></i>
            {t("ged.nouveauDos")}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group className="mb-4">
              <Form.Label className="form-label">
                <i className="fas fa-folder me-2"></i>
                {t("ged.nomDos")}
              </Form.Label>
              <Form.Control
                type="text"
                value={newFolderName}
                onChange={(e) => setNewFolderName(e.target.value)}
                placeholder="Entrez le nom du dossier..."
                className="form-input"
              />
            </Form.Group>

            <Button 
              className="w-100 btn-create" 
              onClick={createFolder}
              disabled={!newFolderName.trim()}
            >
              <i className="fas fa-plus me-2"></i>
              {t("ged.creer")}
            </Button>
          </Form>
        </Modal.Body>
      </Modal>
      <CreateDocumentModal
        show={showDocumentModal}
        handleClose={() => setShowDocumentModal(false)}
        onDocumentCreated={(doc) => console.log("Document créé:", doc)}
        foldersAdd={foldersAdd}
      />
    </div>
  );
};

export default FolderDetail;
